module.exports = __webpack_public_path__ + "img/title.9ea06e6.png";